import { error } from "./error";
import { info } from "./info";
import { primary } from "./primary";
import { secondary } from "./secondary";
import { success } from "./success";
import { warning } from "./warning";
import { tertiary } from "./tertiary";
import { grey } from "./grey";
import { chart } from "./chart";
import { leftMenu } from "./leftMenu";

export const palette = {
  primary: {
    main: primary[700],
    ...primary,
  },
  secondary: {
    main: secondary[700],
    ...secondary,
  },
  error: {
    main: error[800],
    ...error,
  },
  warning: {
    main: warning[800],
    ...warning,
  },
  info: {
    main: info[500],
    ...info,
  },
  success: {
    main: success[800],
    ...success,
  },
  tertiary: {
    main: tertiary[800],
    ...tertiary,
  },
  grey: {
    main: grey[800],
    ...grey,
  },
  chart: {
    ...chart,
  },
  leftMenu: {
    ...leftMenu,
  },
};
